"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTabeNameForAnalytics = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const getTabeNameForAnalytics = (toolType) => {
    switch (toolType) {
        case bridge_schema_1.InfoBoxTabType.Description:
            return 'info';
        case bridge_schema_1.InfoBoxTabType.Isolate:
            return 'isolate';
        case bridge_schema_1.InfoBoxTabType.BoneParts:
            return 'parts';
        case bridge_schema_1.InfoBoxTabType.BoneSurfaces:
            return 'surfaces';
        case bridge_schema_1.InfoBoxTabType.BoneLandmarks:
            return 'landmarks';
        case bridge_schema_1.InfoBoxTabType.Motion:
            return 'motion';
        case bridge_schema_1.InfoBoxTabType.MuscleOI:
            return 'muscle_oi';
        case bridge_schema_1.InfoBoxTabType.Innervation:
            return 'nerves';
        case bridge_schema_1.InfoBoxTabType.ArterialSupply:
            return 'arteries';
        case bridge_schema_1.InfoBoxTabType.CrossSections:
            return 'cross_sections';
        case bridge_schema_1.InfoBoxTabType.OriginTrace:
            return 'origin_path';
        case bridge_schema_1.InfoBoxTabType.BranchesTrace:
            return 'branches';
        case bridge_schema_1.InfoBoxTabType.DrainageTrace:
            return 'drainage_path';
        case bridge_schema_1.InfoBoxTabType.TributariesTrace:
            return 'tributaries';
        case bridge_schema_1.InfoBoxTabType.VideosTreatments:
            return 'treatments';
        case bridge_schema_1.InfoBoxTabType.VideosConditions:
            return 'conditions';
        case bridge_schema_1.InfoBoxTabType.VideosExercises:
            return 'exercises';
        case bridge_schema_1.InfoBoxTabType.VideosStretches:
            return 'stretches';
        case bridge_schema_1.InfoBoxTabType.Sutures:
            return 'sutures';
        case bridge_schema_1.InfoBoxTabType.Craniometrics:
            return 'craniometrics';
        case bridge_schema_1.InfoBoxTabType.Models:
            return 'models';
        default:
            return 'unknown';
    }
};
exports.getTabeNameForAnalytics = getTabeNameForAnalytics;
